import React from "react";
import ServiceWorldInitialCase from "@/src/components/Serviceworld/ServiceWorldInitialCase";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

const ServiceWorldInitialCasePage = () => {
  return (
    <LayoutProtectedRoutes>
      <ServiceWorldInitialCase />
    </LayoutProtectedRoutes>
  );
};

export default ServiceWorldInitialCasePage;
